import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import classNames from 'classnames';

@observer
class StudioSelect extends Component {
    render() {
        const {options, value, label, title, onChange, className, disabled} = this.props;
        const selectClasses = classNames({
            'select-wrapper': true,
            'select-disabled': disabled,
            [className]: true
        });
        return (
            <div className={selectClasses}>
                <select value={value} className="select-list" disabled={disabled} onChange={onChange}>
                    {options.map((option, index) => (
                        <option key={index} value={option.value}>{option.label}</option>
                    ))}
                </select>
                <div className="select-value">{label || value}</div>
                {title && <div className="select-label">{title}</div>}
            </div>
        );
    }
}

StudioSelect.propTypes = {
    options: PropTypes.array.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]).isRequired,
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    className: PropTypes.string
};

export default StudioSelect;
